import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import EhsService from "../services/EhsService";
import UsersService from "@velocity-ehs/user-utils-module";
import {
  getPagination,
  PaginationQueryObject,
  QuerySort,
} from "../components/supportFunctions/graphql/Queries";
import { useQuery } from "@tanstack/react-query";

function useGetEhsRoles(params?: any) {
  const { showSnackbar } = useSnackbarActionContext();
  const { pagination, filters } = formatParams(params);

  const result = useQuery({
    queryKey: ["ehsRoles", params],
    queryFn: () => EhsService.getEhsRoles(pagination, filters),
    retry: false,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    ehsRoles: result.data?.items || [],
    pagination: result.data?.pageInfo || {},
  };
}

function formatParams(params: any) {
  let querySort: QuerySort = null;

  if (params.sortField && params.sortOrder) {
    querySort = {
      sortField: params.sortField,
      sortDirection: params.sortOrder,
    } as QuerySort;
  }

  let pagination: PaginationQueryObject = getPagination(
    params.page + 1,
    params.rows,
    querySort
  );

  const filters = {
    and: {
      customerId: UsersService.customer.id,
      name: params.filters["name"].value || undefined,
    },
  };

  return { filters, pagination };
}

export { useGetEhsRoles };
